import { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { getInsuranceCompanies } from "../../../../services/consignado/insurance-company.service";

interface Props {
  onChange: (value: string | null) => void;
  value?: string | { value: string; label: string };
  error?: string;
  touched?: boolean;
}

const InsuranceCompaniesSelect = ({ onChange, value, error, touched }: Props) => {
  const [defaultOption, setDefaultOption] = useState<any>(null);

  // Carrega valor inicial (para edição)
  useEffect(() => {
    const loadInitialValue = async () => {
      if (typeof value === "string" && value) {
        try {
          const data = await getInsuranceCompanies({ page: 0, pageSize: 50 });
          const company = data.find((el) => el.id === value);
          if (company) {
            setDefaultOption({ value: company.id, label: company.name });
          }
        } catch (err) {
          console.error("Erro ao carregar valor inicial da seguradora:", err);
        }
      } else if (value && typeof value === "object") {
        setDefaultOption(value);
      }
    };

    loadInitialValue();
  }, [value]);

  const loadOptions = async ({ page }: any) => {
    const data = await getInsuranceCompanies({
      pageSize: 50,
      page: page || 0 * 20,
    });

    return {
      options: data.map((item: any) => ({
        value: item.id,
        label: item.name,
      })),
    };
  };

  const isInvalid = touched && !!error;

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      margin: "4px 0 0 0",
      backgroundColor: "white",
      // Lógica de cor da borda baseada no erro
      borderColor: isInvalid ? "#E53E3E" : (state.isFocused ? "#3182ce" : "#E2E8F0"), 
      borderRadius: "0.35rem", 
      minHeight: "40px", 
      boxShadow: isInvalid ? "0 0 0 1px #E53E3E" : (state.isFocused ? "0 0 0 1px #3182ce" : "none"),
      "&:hover": {
        borderColor: isInvalid ? "#E53E3E" : (state.isFocused ? "#3182ce" : "#cbd5e0"),
      }
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
  };

  return (
    <div style={{ width: "100%" }}>
      <label style={{ color: isInvalid ? "#E53E3E" : "inherit" }}>Seguradora</label>
      <AsyncPaginate
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={customStyles}
        value={defaultOption}
        loadOptions={loadOptions as any}
        onChange={(selected: any) => onChange(selected?.value || null)}
        additional={{ page: 0 }}
        debounceTimeout={400}
        isClearable
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
      />
      {isInvalid && (
        <div style={{ color: "#E53E3E", fontSize: "12px", marginTop: "4px" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default InsuranceCompaniesSelect;
